__turbopack_context__.v({
  "contentParent": "t_WBJG_contentParent",
  "ctaContainer": "t_WBJG_ctaContainer",
  "imageWrapper": "t_WBJG_imageWrapper",
  "imagesContainer": "t_WBJG_imagesContainer",
  "progressCTA": "t_WBJG_progressCTA",
  "sectionContainer": "t_WBJG_sectionContainer",
  "titleSection": "t_WBJG_titleSection",
});
